import { IncidentProduct } from '@hakimo-ui/hakimo/types';
import {
  resolveLocationAlarmDataVersion,
  withAuthz,
  withErrorBoundary,
} from '@hakimo-ui/hakimo/util';
import { useParams, useSearchParams } from 'react-router-dom';
import { IncidentDetailsPage } from './IncidentDetailsPage';

interface Props {
  product: IncidentProduct;
}

export const IncidentDetailsWrapper = ({ product }: Props) => {
  const { alarmId } = useParams<{ alarmId: string }>();
  const [searchParams] = useSearchParams();
  // Never the operator's toggle: a deep link must reopen against the same
  // dataset it was copied from. With no param we fall back to the shape of the
  // location alarm id, so a hand-typed v3 link still resolves. Scan is pinned to
  // v2, so a hand-crafted ?version=v3 on a scan URL is ignored.
  const dataVersion =
    product === 'scan'
      ? undefined
      : resolveLocationAlarmDataVersion(searchParams, alarmId);

  if (!alarmId) {
    return (
      <div className="p-6 text-center">
        <p className="text-onlight-text-3 dark:text-ondark-text-2">
          No alarm ID found in URL.
        </p>
      </div>
    );
  }

  return (
    <IncidentDetailsPage
      alarmId={alarmId}
      product={product}
      dataVersion={dataVersion}
    />
  );
};

export default withAuthz(withErrorBoundary(IncidentDetailsWrapper), [
  'location_incidents:view',
  'location_incidents/details:view',
]);
